/* ============================================
   COLLECTION — Scroll Reveal + Interactions
   ============================================ */

(function () {
  'use strict';

  /* ---- Scroll reveal for product cards ---- */
  var cards = document.querySelectorAll('[id$="__collection"] .grid-item');

  if (cards.length) {
    cards.forEach(function (card) {
      card.setAttribute('data-noxor-reveal', '');
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var card = entry.target;
            var index = Array.prototype.indexOf.call(cards, card);
            var row = Math.floor(index / 3);
            var col = index % 3;
            var delay = row === 0 ? col * 120 : col * 80;

            setTimeout(function () {
              card.setAttribute('data-noxor-reveal', 'visible');
            }, delay);

            observer.unobserve(card);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    cards.forEach(function (card) {
      observer.observe(card);
    });
  }

  /* ---- Stats bar counter animation ---- */
  var statsSection = document.querySelector('.noxor-stats');

  if (statsSection) {
    var counters = statsSection.querySelectorAll('[data-count-to]');
    var hasRun = false;

    function animateCounter(el) {
      var target = parseInt(el.getAttribute('data-count-to'), 10);
      var prefix = el.getAttribute('data-count-prefix') || '';
      var suffix = el.getAttribute('data-count-suffix') || '';
      var duration = 1500;
      var start = null;

      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var current = Math.floor(eased * target);
        el.textContent = prefix + current.toLocaleString('en-US') + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }

      requestAnimationFrame(step);
    }

    var statsObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !hasRun) {
            hasRun = true;
            counters.forEach(function (el, i) {
              setTimeout(function () { animateCounter(el); }, i * 150);
            });
            statsObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    statsObserver.observe(statsSection);
  }

  /* ---- Testimonials per-card reveal ---- */
  var testCards = document.querySelectorAll('.noxor-test__card');

  if (testCards.length) {
    testCards.forEach(function (card) {
      card.classList.add('reveal-ready');
    });

    var testObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var card = entry.target;
            var index = Array.prototype.indexOf.call(testCards, card);
            setTimeout(function () {
              card.classList.add('revealed');
            }, index * 120);
            testObserver.unobserve(card);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    testCards.forEach(function (card) {
      testObserver.observe(card);
    });
  }

  /* ---- Filter drawer open/close ---- */
  var filterTrigger = document.getElementById('noxor-filter-trigger');
  var filterDrawer = document.getElementById('noxor-filter-drawer');
  var drawerOverlay = document.getElementById('noxor-drawer-overlay');
  var drawerClose = document.getElementById('noxor-drawer-close');

  function openDrawer() {
    if (!filterDrawer) return;
    filterDrawer.classList.add('active');
    drawerOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!filterDrawer) return;
    filterDrawer.classList.remove('active');
    drawerOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (filterTrigger) filterTrigger.addEventListener('click', openDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

  /* ---- Dual range slider ---- */
  var rangeMin = document.getElementById('noxor-range-min');
  var rangeMax = document.getElementById('noxor-range-max');
  var rangeFill = document.getElementById('noxor-range-fill');
  var minDisplay = document.getElementById('noxor-price-min-display');
  var maxDisplay = document.getElementById('noxor-price-max-display');

  function updateRange() {
    if (!rangeMin || !rangeMax || !rangeFill) return;
    var min = parseInt(rangeMin.value);
    var max = parseInt(rangeMax.value);
    var total = parseInt(rangeMax.max);

    if (min > max - 50) {
      rangeMin.value = max - 50;
      min = max - 50;
    }

    rangeFill.style.left = (min / total * 100) + '%';
    rangeFill.style.width = ((max - min) / total * 100) + '%';
    if (minDisplay) minDisplay.textContent = '$' + min;
    if (maxDisplay) maxDisplay.textContent = '$' + max;
  }

  if (rangeMin) rangeMin.addEventListener('input', updateRange);
  if (rangeMax) rangeMax.addEventListener('input', updateRange);

  /* ---- Apply filters (sort + price) ---- */
  var applyBtn = document.getElementById('noxor-filter-apply');
  if (applyBtn) {
    applyBtn.addEventListener('click', function () {
      var url = new URL(window.location);

      var selectedSort = document.querySelector('input[name="noxor-sort"]:checked');
      if (selectedSort) {
        url.searchParams.set('sort_by', selectedSort.value);
      }

      var min = rangeMin ? rangeMin.value : '0';
      var max = rangeMax ? rangeMax.value : '600';
      if (min !== '0') {
        url.searchParams.set('filter.v.price.gte', min);
      } else {
        url.searchParams.delete('filter.v.price.gte');
      }
      if (max !== '600') {
        url.searchParams.set('filter.v.price.lte', max);
      } else {
        url.searchParams.delete('filter.v.price.lte');
      }

      closeDrawer();
      window.location = url.toString();
    });
  }

  /* ---- Clear all filters ---- */
  var clearBtn = document.getElementById('noxor-filter-clear');
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      var url = new URL(window.location);
      url.searchParams.delete('filter.v.price.gte');
      url.searchParams.delete('filter.v.price.lte');
      url.searchParams.delete('sort_by');
      window.location = url.toString();
    });
  }

  /* ---- Sync state from URL on load ---- */
  var urlParams = new URLSearchParams(window.location.search);
  var hasPrice = urlParams.has('filter.v.price.gte') || urlParams.has('filter.v.price.lte');
  var hasSort = urlParams.has('sort_by') && urlParams.get('sort_by') !== 'manual';
  var activeCount = (hasPrice ? 1 : 0) + (hasSort ? 1 : 0);

  if (activeCount > 0) {
    var filterCount = document.getElementById('noxor-filter-count');
    if (filterCount) {
      filterCount.textContent = activeCount;
      filterCount.classList.add('active');
    }
  }

  if (hasPrice) {
    if (rangeMin) rangeMin.value = urlParams.get('filter.v.price.gte') || '0';
    if (rangeMax) rangeMax.value = urlParams.get('filter.v.price.lte') || '600';
  }

  updateRange();
})();
